export const isValidAttributeName = (name: string) => /^([A-Z]|[0-9])[A-Z0-9 ]*([A-Z]|[0-9])*$/i.test(name);
